import { render, staticRenderFns } from "./invenGoodsDetails.vue?vue&type=template&id=367038a8&scoped=true&"
import script from "./invenGoodsDetails.vue?vue&type=script&lang=js&"
export * from "./invenGoodsDetails.vue?vue&type=script&lang=js&"
import style0 from "./invenGoodsDetails.vue?vue&type=style&index=0&id=367038a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367038a8",
  null
  
)

component.options.__file = "invenGoodsDetails.vue"
export default component.exports